// src/services/Unsplash.ts
import _2 from "lodash";

// src/helpers/Deeply.ts
import _ from "lodash";
_.mixin({
  deeply: (map) => {
    return (object, callback) => {
      return map(
        _.mapValues(object, (value) => {
          return _.isPlainObject(value) ? _.deeply(map)(value, callback) : value;
        }),
        callback
      );
    };
  }
});

// src/helpers/StringUtils.ts
function camelToSnakeCase(str) {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}
function snakeToCamel(str) {
  return str.replace(/_([a-z])/g, (_3, letter) => letter.toUpperCase());
}

// src/services/Unsplash.ts
var UnsplashImpl = class {
  clientId;
  baseUrl = "https://api.unsplash.com";
  locale;
  subPaths = {
    photos: "/photos",
    collections: "/collections",
    search: "/search/photos"
  };
  constructor(clientId, initialLocale) {
    this.clientId = clientId;
    this.locale = initialLocale;
  }
  getPhoto(id) {
    const path = `${this.subPaths.photos}/${id}`;
    return this.fetch(path);
  }
  getEditorialPhotos(page, perPage) {
    const path = this.subPaths.photos;
    return this.fetch(path, { page, perPage });
  }
  getPhotosInCollection(collectionId, page, perPage) {
    const path = `${this.subPaths.collections}/${collectionId}/photos`;
    return this.fetch(path, { page, perPage });
  }
  trackPhotoDownload(id) {
    const path = `${this.subPaths.photos}/${id}/download`;
    return this.fetch(path);
  }
  searchPhotos(params) {
    const path = this.subPaths.search;
    return this.fetch(path, params);
  }
  setLocale(locale) {
    this.locale = locale;
  }
  async fetch(path, queryParams) {
    const url = new URL(`${this.baseUrl}${path}`);
    url.searchParams.append("client_id", this.clientId);
    url.searchParams.append("locale", this.locale);
    if (queryParams) {
      const formattedQueryParams = _2.deeply(_2.mapKeys)(queryParams, (_3, key) => camelToSnakeCase(key));
      Object.entries(formattedQueryParams).forEach(([key, value]) => {
        url.searchParams.append(key, String(value));
      });
    }
    const response = await fetch(url.toString());
    if (!response.ok) {
      throw new Error(`Failed to fetch ${url.toString()}`);
    }
    const json = await response.json();
    if (_2.isArray(json)) {
      return json.map((value) => _2.deeply(_2.mapKeys)(value, (_3, key) => snakeToCamel(key)));
    } else {
      return _2.deeply(_2.mapKeys)(json, (_3, key) => snakeToCamel(key));
    }
  }
};

// src/index.ts
function createUnsplash(clientId, initialLocale) {
  return new UnsplashImpl(clientId, initialLocale);
}
export {
  UnsplashImpl,
  createUnsplash
};
